import React from 'react';
import { useGameState } from '../hooks/useGameState';
import ScorePanel from './ScorePanel';
import ColorGrid from './ColorGrid';
import GameMessage from './GameMessage';
import GameControls from './GameControls';
import GridSizeSelector from './GridSizeSelector';
import DifficultySelector from './DifficultySelector';

const GameBoard = () => {
  const {
    grid,
    gridWidth,
    gridHeight,
    ownership,
    isPlayerTurn,
    playerColor,
    aiColor,
    playerScore,
    aiScore,
    gameOver,
    winner,
    message,
    availableColors,
    isAnimating,
    currentPlayer,
    handleColorChange,
    handleGridSizeChange,
    handleDifficultyChange,
    restartGame,
    isCellAnimating,
    getCellAnimationStyle,
    difficulty
  } = useGameState();

  const handleTileClick = (color) => {
    if (isPlayerTurn && !gameOver && !isAnimating) {
      handleColorChange(color);
    }
  };

  return (
    <div style={{
      textAlign: "center",
      fontFamily: "Arial, sans-serif",
      maxWidth: "100%",
      width: "100%",
      margin: "0 auto",
      padding: "10px",
      boxSizing: "border-box"
    }}>
      <h1 style={{marginBottom: "10px", fontSize: "clamp(24px, 5vw, 32px)"}}>Color Conquer</h1>
      
      <ScorePanel 
        playerScore={playerScore}
        playerColor={playerColor}
        aiScore={aiScore}
        aiColor={aiColor}
        isPlayerTurn={isPlayerTurn}
      />
      
      <div style={{ marginBottom: "15px" }}>
        <h3 style={{ marginBottom: "8px", fontSize: "clamp(16px, 4vw, 20px)" }}>Grid Size</h3>
        <GridSizeSelector 
          currentWidth={gridWidth}
          currentHeight={gridHeight}
          onSizeChange={handleGridSizeChange} 
        />
      </div>

      <div style={{ marginBottom: "15px" }}>
        <h3 style={{ marginBottom: "8px", fontSize: "clamp(16px, 4vw, 20px)" }}>AI Difficulty</h3>
        <DifficultySelector 
          currentDifficulty={difficulty}
          onDifficultyChange={handleDifficultyChange}
        />
      </div>
      
      <div style={{ 
        width: "100%", 
        display: "flex", 
        justifyContent: "center",
        overflow: "auto"
      }}>
        <ColorGrid 
          grid={grid}
          gridWidth={gridWidth}
          gridHeight={gridHeight}
          ownership={ownership}
          handleTileClick={handleTileClick}
          isCellAnimating={isCellAnimating}
          getCellAnimationStyle={getCellAnimationStyle}
          availableColors={availableColors}
          playerColor={playerColor}
          aiColor={aiColor}
          isPlayerTurn={isPlayerTurn}
          gameOver={gameOver}
          isAnimating={isAnimating}
          currentPlayer={currentPlayer}
        />
      </div>
      
      <GameMessage 
        message={message}
        gameOver={gameOver}
      />
      
      <GameControls 
        restartGame={restartGame}
        gameOver={gameOver}
        winner={winner}
        isPlayerTurn={isPlayerTurn}
      />
    </div>
  );
};

export default GameBoard;